<fm-geofence-form
  [geoFenceAddress]="geoFenceAddress$ | async"
  [placeCategories]="placeCategories$ | async"
  [hierarchyGroups]="hierarchyGroups$ | async"
  [mandatoryGeofenceGroupsEnabled]="mandatoryGeofenceGroupsEnabled$ | async"
  [geoFenceForm]="placeLoaded$ | async"
  (saveGeofence)="saveGeofence($event)"
  (closeGeofencePanel)="closeGeofencePanel()"
>
</fm-geofence-form>
